import Pulse from './animations/Pulse.json'
import lottie from 'lottie-web'
import { StyledLogoAnimation } from './LogoAnimation.style'
import { useEffect } from 'react'

const LogoAnimation = () => {
  useEffect(() => {
    lottie.loadAnimation({
      animationData: JSON.parse(JSON.stringify(Pulse)),
      container: document.querySelector('#yolda-logo'),
    })
  }, [])

  return (
    <StyledLogoAnimation>
      <div id="yolda-logo" />
    </StyledLogoAnimation>
  )
}

export default LogoAnimation
